import Grid from "@mui/material/Grid2";
import FormField from "components/cck/FormField";
import { Controller, useFormContext } from "react-hook-form";
import LocationSelect from "view/locations/components/selects/LocationSelect";
import { LocationType } from "__generated__/graphql";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Fragment, ReactNode } from "react";
import type { AgreementFormByTypeProps } from "@schemas/agreements/schema";

type FormValues = {
	agreements: {
		location?: {
			id: number;
			description: string;
			type: LocationType;
			locationGroups: {
				id: number;
				description: string
				type: LocationType;
			}[];
		};
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}

const WaterwayAgreementForm = ({ index, hiddenFields }: AgreementFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const WaterwayAgreementFormFields: FormField[] = [
		{
			id: "agreement.location",
			render: () => (
				<Grid size={{ md: 4, xs: 12 }}>
					<FormField errors={errors} name={`agreements.${index}.location`}>
						<FormGroup label={intl.formatMessage({ id: "LOCATION" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.location`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<LocationSelect
										{...field}
										value={field.value ?? null}
										onChange={option => field.onChange(option ?? undefined)}
										multiple={false}
										types={[ LocationType.BorderCrossing ]}
									/>
								)}
							/>
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<>
			{WaterwayAgreementFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default WaterwayAgreementForm;
